import React from 'react';
import { render } from 'react-dom';
import { getPartner } from './helpers/partner';
import App from './App';
import appConfig from './app.config';
import { loadOTBanner } from 'helpers/seo';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import './styles/reset.css';
import './styles/layout.css';
import './styles/global.css';

import './modules/dayjs-setup';
import './Sentry';
import getStaticUrl from 'helpers/staticContent';

const partner = getPartner();
const partnerConfig = appConfig[partner];

const { ga, gtm } = partnerConfig || {};

if (ga && gtm) {
  ReactGA.initialize(ga);
  TagManager.initialize({ gtmId: gtm });
}

window.dataLayer = window.dataLayer || [];
if (gtm) {
  window.dataLayer.push({
    event: 'initialPageView',
  });
}

loadOTBanner(appConfig[partner]);
document.title = appConfig[partner]?.title || 'Back Market';
let link = document.querySelector("link[rel~='icon']");
if (!link) {
  link = document.createElement('link');
  link.rel = 'icon';
  document.getElementsByTagName('head')[0].appendChild(link);
}
link.href =
  appConfig[partner]?.favicon ||
  `${getStaticUrl()}/my-customer-space/BM_favicon.ico`;

import(`styles/${partner}.css`)
  .then(() => {
    render(<App />, document.getElementById('root'));
  })
  .catch(() => {
    import('styles/BM.css').then(() => {
      render(<App />, document.getElementById('root'));
    });
  });
